module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--stretch",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "rect rect-1",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-2",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-3",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-4",
    style: (_vm.rectStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-5",
    style: (_vm.rectStyles)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ad611e3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Stretch.vue
// module id = 621
// module chunks = 1